import { useSearchParams } from "react-router-dom";

type ParamsObject = Record<string, string | null>;

export function useFilterStringParams<T extends string>(keys: T[]) {
    const [params, setParams] = useSearchParams();

    const values = keys.reduce((acc, key) => {
        acc[key] = params.get(key);
        return acc;
    }, {} as ParamsObject);

    const setValues = (newValues: Partial<Record<T, string | null | undefined>>) => {
        const updated = new URLSearchParams(params);

        Object.entries(newValues).forEach(([key, value]) => {
            if (typeof value === "string" && value.trim() !== "") {
                updated.set(key, value);
            } else {
                updated.delete(key);
            }
        });

        setParams(updated, { replace: true });
    };

    return [values as Record<T, string | null>, setValues] as const;
}
